import { TableBody } from '@mui/material'
import Table from 'features/common/ui/Table/Table'
import { useIntegrations } from 'features/integrations/hooks/integrationsHooks'
import IntegrationsTableHeader from './IntegrationsTableHeader'
import IntegrationsTableRow from './IntegrationsTableRow'
import IntegrationBucketContextMenu from './IntegrationBucket/IntegrationBucketContextMenu'
import IntegrationExternalIdpContextMenu from './IntegrationExternalIdp/IntegrationExternalIdpContextMenu'
import { IntegrationType } from 'features/integrations/types'
import { IntegrationPaths } from '../paths'
import WorkloadIdentityFederationContextMenu from '../IntegrationsForm/WorkloadIdentityFederation/WorkloadIdentityFederationContextMenu'
import DatabricksOAuthU2MContextMenu from '../IntegrationsForm/DatabricksOAuthU2M/DatabricksOAuthU2MContextMenu'

function IntegrationsTable() {
  const integrations = useIntegrations()
  return (
    <Table>
      <IntegrationsTableHeader />
      <TableBody>
        {integrations.map((integration) => (
          <IntegrationsTableRow
            key={integration.integrationType}
            loading={integration.isLoading}
            integration={integration}
            addNewUri={
              integration.integrationType === IntegrationType.ExternalIdp
                ? IntegrationPaths.ExternalIdpForm()
                : integration.integrationType === IntegrationType.BQWorkloadIdentityFederation
                ? IntegrationPaths.WorkloadIdentityFederation()
                : integration.integrationType === IntegrationType.DatabricksOAuthU2M
                ? IntegrationPaths.DatabricksOAuthU2M()
                : IntegrationPaths.BucketForm(integration)
            }
            actions={
              integration.integrationType === IntegrationType.ExternalIdp ? (
                <IntegrationExternalIdpContextMenu integration={integration} />
              ) : integration.integrationType === IntegrationType.BQWorkloadIdentityFederation ? (
                <WorkloadIdentityFederationContextMenu />
              ) : integration.integrationType === IntegrationType.DatabricksOAuthU2M ? (
                <DatabricksOAuthU2MContextMenu id={integration.id || ''} />
              ) : (
                <IntegrationBucketContextMenu integration={integration} />
              )
            }
          />
        ))}
      </TableBody>
    </Table>
  )
}

export default IntegrationsTable
